import { Action, initialState, State } from "store/store";

export const setCurrentInteraction = (
  state: State = initialState,
  { data }: Action
): State => {
  return {
    ...state,
    ...(data.updateFocusedNodeId && {
      focusedNodeId: data.id,
    }),
    currentInteraction: data.id,
  };
};
